import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getTier, TRIAL_DAYS } from '../../../Data/PricingData';
import '../../../Styles/Layout/Items/SubscriptionPromo.css';

const SubscriptionPromo: React.FC = () => {
  const navigate = useNavigate();

  const ultimateTier = getTier('ultimate')!;

  const handleUpgradeClick = () => {
    navigate('/pricing?ref=settings');
  };

  return (
    <div className="subscription-promo">
      <div className="promo-content">
        <div className="promo-header">
          <h3 className="promo-title">Get More From Buddy</h3>
          <p className="promo-description">
            Try <span className="promo-highlight">{ultimateTier.name}</span> free for <span className="promo-highlight">{TRIAL_DAYS} days</span>. Cancel anytime.
          </p>
        </div>

        <ul className="promo-feature-list">
          {ultimateTier.features.map((feature) => (
            <li className="promo-feature-item" key={feature}>
              {feature}
            </li>
          ))}
        </ul>

        <button type="button" onClick={handleUpgradeClick} className="promo-upgrade-button">
          <span>Start Free Trial</span>
          <svg className="button-arrow" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16797 10H15.8346" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.834 5L15.834 10L10.834 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      
      <div className="promo-decoration">
        <div className="decoration-circle"></div>
        <div className="decoration-shape"></div>
        <div className="decoration-pattern"></div>
      </div>
    </div>
  );
};

export default SubscriptionPromo;
